module.exports = __webpack_public_path__ + "img/m_cwqr.05c7befb.png";